import { environment } from '../../../environments/environment';
import * as angular from 'angular';

angular.module('ConfigPlatform', ['LexiconControllers'])

.constant('API_URL', environment.API_URL)

.constant('EXAM', environment.EXAM)

.constant('ENVIRONMENT', environment.ENVIRONMENT)

;
